import { combineReducers } from 'redux';
import shop from './shop';

const rootReducer = combineReducers({
    shop
});

export default rootReducer;